module.exports = __webpack_public_path__ + "static/fonts/Fact-CompressedBlack.2acc007.woff";